export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage && errorMessage.indexOf('CANT_REMOVE_LET_IN_PLACE') === 0) {
      messages.push({
        message: 'gestionAffectation.popUpPreventionLaisserEnPlace.errorImpossibleEnlverLaisserEnPace',
      });
    }
    if (errorMessage && errorMessage.indexOf('WRONG_LOGISTIC_ACTION_TO_LET_IN_PLACE') === 0) {
      const elements = errorMessage.split('|')[0].split('@');
      const nbFace = elements[1];
      const facesCode = elements[2];
      if (nbFace === '1') {
        messages.push({
          message: 'listeDemande.tab.echec.letInPlace',
          parametres: { face: facesCode },
        });
      } else {
        messages.push({
          message: 'listeDemande.tab.echec.letInPlaces',
          parametres: { faces: facesCode },
        });
      }
    }
  });
}
